import React, { useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { ClearSvg, VisibleOffSvg, VisibleOnSvg } from "../Assets";
const AppInputPassword = ({ control, name, placeholder, label, className, clearable }) => {
  const [visible, setVisible] = useState(false);
  const [isFocused, setIsFocused] = useState(false)
  const inputRef = useRef();

  return (
    <div className={"app-input-wrapper " + className}>
      <Controller
        name={name}
        control={control}
        defaultValue=""
        render={({ field, formState, fieldState }) => {
          const isError =  formState.errors[name];
          const hasValue = field.value;

          return (
            <div>
              <input
                {...field}
                type={visible ? "text" : "password"}
                onFocus={()=>setIsFocused(true)}
                onBlur={()=>setIsFocused(false)}
                className={
                  isError
                    ? "app-input error"
                    : hasValue
                    ? isFocused
                      ? "app-input focus"
                      : "app-input hasValue"
                    : "app-input"
                }
                placeholder={placeholder}
                ref={(e) => {
                  field.ref(e);
                  inputRef.current = e;
                }}
              />
              <div className="password-clear-button">
                {hasValue && clearable && (
                  <img
                    className="clear-icon"
                    onClick={() => {
                      field.onChange("");
                      inputRef.current.focus();
                    }}
                    src={ClearSvg}
                  />
                )}
                <img
                  className="show-hide-icon"
                  onClick={() => setVisible(!visible)}
                  src={visible ? VisibleOnSvg : VisibleOffSvg}
                />
              </div>
              <div className="app-input-label">{label}</div>
            </div>
          );
        }}
      />
    </div>
  );
};

export default AppInputPassword;
